import React, { useState } from 'react';
import ParametersForm from './parameters_form';
import ParametersList from './parameters_list';
import styles from '../../app.module.css'

const ParametersSection = ({ parameters, addParameter, editParameter, removeParameter }) => {
    const [currentParameter, setCurrentParameter] = useState(null);
    const [isEditingMode, setIsEditingMode] = useState(false);

    const handleAdd = () => {
        setCurrentParameter({});
        setIsEditingMode(false);
    };

    const handleEdit = (parameterName) => {
        setCurrentParameter({ name: parameterName, ...parameters[parameterName] });
        setIsEditingMode(true);
    };

    const handleSave = (name, parameterData) => {
        if (isEditingMode) {
            editParameter(currentParameter.name, parameterData);
        } else {
            addParameter(name, parameterData);
        }
        setCurrentParameter(null);
    };

    const handleCancel = () => {
        setCurrentParameter(null);
    };

    return (
        <div className="parameters-container">
            <h3 className={styles.centeredHeading}>Parameters</h3>

            <ParametersList
                parameters={parameters}
                currentParameter={currentParameter}
                onEdit={handleEdit}
                onDelete={removeParameter}
                onSave={handleSave}
                onCancel={handleCancel}
            />

            {!isEditingMode && currentParameter && (
                <ParametersForm
                    initialData={currentParameter}
                    isEditing={false}
                    onSave={handleSave}
                    onCancel={handleCancel}
                    existingParameters={parameters}
                />
            )}

            {!currentParameter && (
                <button className={styles.addNewButton} onClick={handleAdd}>+ Add Parameter</button>
            )}
        </div>
    );
};

export default ParametersSection;
